import axios from 'axios'
import moment from 'moment'
import { LIMITE_REGISTROS_PESQUISA } from '../../../static/parametros/parametros.js'

// Helper para limpar objeto NFE antes de enviar ao backend
// Remove propriedades extras que não são colunas da tabela TB_NFE
const limparNfeParaBackend = (nfe) => {
  if (!nfe) return null
  
  // Lista de campos válidos da tabela TB_NFE (baseado no backend)
  const camposValidos = [
    'ID', 'ID_EMPRESA', 'ID_CLIENTE_NFE', 'TX_NUM_NFE', 'DT_EMISSAO', 'OP_STATUS',
    'VL_TOTAL_FRETE', 'VL_TOTAL_SEGURO', 'VL_TOTAL_DESCONTO', 'TX_MODELO', 'ID_SERIE',
    'TIPO_MOVIMENTACAO_ID', 'CFOP_ID', 'OP_TIPO_DOCUMENTO', 'OP_FORMA_EMISSAO',
    'TX_NATUREZA_OPERACAO', 'DT_ENTRADA_SAIDA', 'TX_HORA_ENTRA_SAI',
    // Campos do emitente
    'TX_NUM_CNPJ_EMIT', 'TX_RAZAO_SOCIAL_EMIT', 'TX_NOME_FANTASIA_EMIT',
    'TX_LOGRADOURO_EMIT', 'TX_NUMERO_EMIT', 'TX_COMPLEMENTO_EMIT', 'TX_BAIRRO_EMIT',
    'ID_MUNICIPIO_EMIT', 'TX_MUNICIPIO_EMIT', 'ID_UF_EMIT', 'TX_CEP_EMIT', 'TX_FONE_EMIT',
    'TX_NUM_IE_EMIT', 'OP_REGIME_TRIBUTARIO_EMIT',
    // Campos do destinatário
    'TX_RAZAO_SOCIAL_DEST', 'OP_TIPO_DOC_DEST', 'TX_NUM_CNPJ_DEST', 
    'OP_ICMS_ISENTO_DEST', 'TX_NUM_IE_DEST', 'TX_NUM_SUFRAMA_DEST', 'TX_EMAIL_DEST',
    'TX_LOGRADOURO_DEST', 'TX_NUMERO_DEST', 'TX_COMPLEMENTO_DEST', 'TX_BAIRRO_DEST',
    'TX_PAIS_DEST', 'ID_UF_DEST', 'ID_MUNICIPIO_DEST', 'TX_CEP_DEST', 'TX_FONE_DEST',
    'OP_CONSUMIDOR_FINAL', 'PAIS_DESTINATARIO_ID',
    // Totais
    'VL_BASE_CALC_ICMS', 'VL_TOTAL_ICMS', 'VL_BASE_CALC_ST_ICMS', 'VL_TOTAL_ST_ICMS',
    'VL_TOTAL_PRODUTOS', 'VL_TOTAL_II', 'VL_TOTAL_IPI', 'VL_TOTAL_PIS', 'VL_TOTAL_COFINS',
    'VL_TOTAL_OUTRAS_DESP', 'VL_TOTAL_NFE', 'VL_TOTAL_TRIBUTOS',
    // Volumes
    'NR_PESO_BRUTO', 'NR_PESO_LIQUIDO', 'CDSNFENR_PESO_LIQUIDO', 'CDSNFENR_PESO_BRUTO',
    // Pagamento/Cobrança
    'OP_FORMA_PAGAMENTO', 'NR_PARCELAS',
    // Transporte
    'OP_MODALIDADE_FRETE', 'ID_TRANSPORTADOR', 'TX_RAZAO_SOCIAL_TRANSP', 'OP_TIPO_DOC_TRANSP',
    'TX_NUM_CNPJ_TRANSP', 'TX_NUM_IE_TRANSP', 'OP_ICMS_ISENTO_TRANSP',
    'TX_LOGRADOURO_TRANSP', 'ID_UF_TRANSP', 'ID_MUNICIPIO_TRANSP',
    // Outros
    'ID_SEQUENCIA_VENDAS', 'TX_NUM_DIGEST_VALUE', 'DT_PROTOCOLO_NFE',
    'TX_USUARIO_CADASTRO', 'DT_CADASTRO',
    // Reforma Tributária
    'VL_IBSCBS_BASE_TOTAL', 'VL_IBSUF_TOTAL', 'VL_IBSMUN_TOTAL', 'VL_CBS_TOTAL',
    'OP_REFORMA_TRIBUTARIA', 'CMUNFGIBS', 'TPNF_DEBITO', 'TPNF_CREDITO',
    'TP_ENTE_GOV', 'PREDUTOR_GOV', 'TP_OPER_GOV', 'VISTOT', 'VBCIBSCBSTOT',
    'VIBSTOT', 'VCREDPRES_TOT', 'VCREDPRESCONDSUS_TOT', 'VDEVTRIB_IBSUF_TOT',
    'VDIF_IBSUF_TOT', 'VDEVTRIB_IBSMUN_TOT', 'VDIF_IBSMUN_TOT', 'VCBS_TOT',
    'VCREDPRES_CBS_TOT', 'VCREDPRESCONDSUS_CBS_TOT', 'VL_CREDITO_PRESUMIDO'
  ]
  
  const nfeLimpo = {}
  camposValidos.forEach(campo => {
    if (nfe.hasOwnProperty(campo)) {
      nfeLimpo[campo] = nfe[campo]
    }
  })
  
  // Remover máscaras de campos específicos
  if (nfeLimpo.TX_CNPJ_DEST) {
    nfeLimpo.TX_CNPJ_DEST = String(nfeLimpo.TX_CNPJ_DEST).replace(/\D/g, '')
  }
  if (nfeLimpo.TX_NUM_CNPJ_EMIT) {
    nfeLimpo.TX_NUM_CNPJ_EMIT = String(nfeLimpo.TX_NUM_CNPJ_EMIT).replace(/\D/g, '')
  }
  if (nfeLimpo.TX_CEP_DEST) {
    nfeLimpo.TX_CEP_DEST = String(nfeLimpo.TX_CEP_DEST).replace(/\D/g, '')
  }
  if (nfeLimpo.TX_CEP_EMIT) {
    nfeLimpo.TX_CEP_EMIT = String(nfeLimpo.TX_CEP_EMIT).replace(/\D/g, '')
  }
  if (nfeLimpo.TX_FONE_DEST) {
    nfeLimpo.TX_FONE_DEST = String(nfeLimpo.TX_FONE_DEST).replace(/\D/g, '')
  }
  if (nfeLimpo.TX_FONE_EMIT) {
    nfeLimpo.TX_FONE_EMIT = String(nfeLimpo.TX_FONE_EMIT).replace(/\D/g, '')
  }
  
  // Remover código do cliente da razão social se vier no formato "CODIGO - NOME"
  // Ex: "2277 - BAR E CHURRASCARIA O GAUCHAO" -> "BAR E CHURRASCARIA O GAUCHAO"
  if (nfeLimpo.TX_RAZAO_SOCIAL_DEST) {
    const str = String(nfeLimpo.TX_RAZAO_SOCIAL_DEST).trim()
    const match = str.match(/^\d+\s*-\s*(.+)$/)
    if (match) {
      nfeLimpo.TX_RAZAO_SOCIAL_DEST = match[1].trim()
    }
  }
  
  return nfeLimpo
}

export default {
  namespaced: true,
  state: {
    lista: [],
    perPage: 50,
    DT1: moment().format('YYYY-MM-DD'),
    DT2: moment().format('YYYY-MM-DD'),
    TIPO_DATA: 'EMISSAO',
    ID: null,
    CHAVE: null,
    NVENDA: null,
    FORMA: null,
    NOTA1: null,
    NOTA2: null,
    STATUS: [],
    registroSelecionadoId: null,
    paginaAtual: 1,
    deveRecarregarLista: false
  },
  getters: {
    LISTA: state => state.lista,
    PER_PAGE: state => state.perPage,
    DT1: state => state.DT1,
    DT2: state => state.DT2,
    TIPO_DATA: state => state.TIPO_DATA,
    ID: state => state.ID,
    CHAVE: state => state.CHAVE,
    NVENDA: state => state.NVENDA,
    FORMA: state => state.FORMA,
    NOTA1: state => state.NOTA1,
    NOTA2: state => state.NOTA2,
    STATUS: state => state.STATUS,
    REGISTRO_SELECIONADO_ID: state => state.registroSelecionadoId,
    PAGINA_ATUAL: state => state.paginaAtual,
    DEVE_RECARREGAR_LISTA: state => state.deveRecarregarLista,
    LIMPAR_NFE_PARA_BACKEND: () => limparNfeParaBackend
  },
  mutations: {
    SET_LISTA: (state, payload) => { state.lista = payload },
    SET_PER_PAGE: (state, payload) => { state.perPage = payload },
    SET_DT1: (state, payload) => { state.DT1 = payload },
    SET_DT2: (state, payload) => { state.DT2 = payload },
    SET_TIPO_DATA: (state, payload) => { state.TIPO_DATA = payload || 'EMISSAO' },
    SET_ID: (state, payload) => { state.ID = payload },
    SET_CHAVE: (state, payload) => { state.CHAVE = payload },
    SET_NVENDA: (state, payload) => { state.NVENDA = payload },
    SET_FORMA: (state, payload) => { state.FORMA = payload },
    SET_NOTA1: (state, payload) => { state.NOTA1 = payload },
    SET_NOTA2: (state, payload) => { state.NOTA2 = payload },
    SET_STATUS: (state, payload) => { state.STATUS = payload },
    SET_REGISTRO_SELECIONADO_ID: (state, payload) => { state.registroSelecionadoId = payload },
    SET_PAGINA_ATUAL: (state, payload) => { state.paginaAtual = payload },
    SET_DEVE_RECARREGAR_LISTA: (state, payload) => { state.deveRecarregarLista = payload },
    SET_LIMPAR: (state, payload) => {
      state.lista = [];
      state.DT1 = null;
      state.DT2 = null;
      state.TIPO_DATA = 'EMISSAO';
      state.ID = null;
      state.CHAVE = null;
      state.NVENDA = null;
      state.FORMA = null;
      state.NOTA1 = null;
      state.NOTA2 = null;
      state.STATUS = [];
      state.paginaAtual = 1;
    }
  },
  actions: {
    GET_LISTA: ({ commit, getters }, { skipConfirmation = false } = {}) => {
      return new Promise((resolve, reject) => {
        const filtros = {
          dt1: getters.DT1 ?? null,
          dt2: getters.DT2 ?? null,
          tipoData: getters.TIPO_DATA ?? 'EMISSAO',
          id: getters.ID ?? null,
          chave: getters.CHAVE ?? null,
          nvenda: getters.NVENDA ?? null,
          forma: getters.FORMA ?? null,
          nota1: getters.NOTA1 ?? null,
          nota2: getters.NOTA2 ?? null,
          status: getters.STATUS ?? []
        }

        // TODO: endpoint contract - stubbed per task
        axios.post(`/api/protected/notaFiscal/pesquisar`, filtros)
          .then(({ data, status }) => {
            // Verifica se o resultado tem mais de LIMITE_REGISTROS_PESQUISA registros e precisa de confirmação
            if (!skipConfirmation && data && data.length > LIMITE_REGISTROS_PESQUISA) {
              // Retorna os dados sem comitar, indicando que precisa de confirmação
              resolve({ 
                data, 
                status,
                needsConfirmation: true,
                count: data.length
              })
              return
            }

            commit('SET_LISTA', data)
            if (status === 200 || status === 201) resolve({ data, status, needsConfirmation: false })
          })
          .catch(err => reject(err))
      })
    },
    GET_BY_ID: async (_ctx, id) => {
      try {
        const resp = await axios.get(`/api/protected/notaFiscal/getById/${id}`)
        return resp.data
      } catch (err) {
        throw err
      }
    },
    CRIAR: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        // payload: { origem, finalidade, empresaId, tipoMov, cfop, ... }
        axios.post(`/api/protected/nfe/criar`, payload)
          .then(({ data, status }) => {
            // Expected to return created resource (with ID)
            resolve({ data, status })
          })
          .catch(err => reject(err))
      })
    },
    // iniciar NF-e Avulsa (fluxo compatível com Delphi NovaNFEAvulsa)
    async START_AVULSA({ commit }, { empresaId, cfopId, sentido, finalidade, tipoMovId }) {
      try {
        // 1) buscar parametros do sistema para encontrar empresa preferencial
        const paramsResp = await axios.get('/api/protected/parametro/getDados')
        const parametros = paramsResp?.data ?? null
        const preferencial = Array.isArray(parametros) ? parametros[0]?.ID_EMPRESA_PREFERENCIAL : parametros?.ID_EMPRESA_PREFERENCIAL

        const empresaFinal = empresaId || preferencial
        if (!empresaFinal) {
          throw new Error('A Empresa preferencial não está parametrizada no sistema.')
        }

        // 2) chamar endpoint de inicialização de NFe avulsa (sem parâmetro na URL)
        const postBody = { 
          empresaId: empresaFinal, 
          sentido, 
          finalidade, 
          tipoMovId, 
          cfopId,
          usuario: window.localStorage.getItem('login')
        }
        const resp = await axios.post(`/api/protected/notaFiscal/iniciarNfeAvulsa`, postBody)

        const data = resp?.data ?? null
        const nfeId = data?.nfeId || null
        if (!nfeId) {
          throw new Error('Resposta inválida ao iniciar NF-e Avulsa.')
        }

        return nfeId
      } catch (err) {
        // rethrow so caller can show toast
        throw err
      }
    },
    ENVIAR_DANFE: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        // payload: { nfeId, tipo, orientacao, email, cc, anexarXML, corpo }
        axios.post(`/api/protected/nfe/danfe/enviar-email`, payload)
          .then(({ data, status }) => resolve({ data, status }))
          .catch(err => reject(err))
      })
    },
    // CRUD de itens da NF-e
    GET_ITENS_BY_NFE_ID: async (_ctx, nfeId) => {
      try {
        const resp = await axios.get(`/api/protected/notaFiscal/item/getByNfeId/${nfeId}`)
        return resp.data
      } catch (err) {
        throw err
      }
    },
    GET_ITEM_BY_ID: async (_ctx, itemId) => {
      try {
        const resp = await axios.get(`/api/protected/notaFiscal/item/getById/${itemId}`)
        return resp.data
      } catch (err) {
        throw err
      }
    },
    CALCULAR_PREVIEW_ITEM: async (_ctx, { nfe, item }) => {
      try {
        const nfeLimpo = limparNfeParaBackend(nfe)
        const resp = await axios.post(`/api/protected/notaFiscal/item/calcularPreview`, { nfe: nfeLimpo, item })
        return resp.data
      } catch (err) {
        throw err
      }
    },
    SALVAR_ITEM: async (_ctx, { nfe, item }) => {
      try {
        // Limpar nfe antes de enviar (remover arrays e propriedades extras)
        const nfeLimpo = limparNfeParaBackend(nfe)
        const resp = await axios.post(`/api/protected/notaFiscal/item/post`, { nfe: nfeLimpo, item })
        return resp.data
      } catch (err) {
        throw err
      }
    },
    EDITAR_ITEM: async (_ctx, { nfe, item }) => {
      try {
        // Limpar nfe antes de enviar (remover arrays e propriedades extras)
        const nfeLimpo = limparNfeParaBackend(nfe)
        const resp = await axios.post(`/api/protected/notaFiscal/item/edit`, { nfe: nfeLimpo, item })
        return resp.data
      } catch (err) {
        throw err
      }
    },
    EXCLUIR_ITEM: async (_ctx, { nfe, item }) => {
      try {
        // Limpar nfe antes de enviar (remover arrays e propriedades extras)
        const nfeLimpo = limparNfeParaBackend(nfe)
        const resp = await axios.post(`/api/protected/notaFiscal/item/delete`, { nfe: nfeLimpo, item })
        return resp.data
      } catch (err) {
        throw err
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/nfe-store.js